<template>
  <v-data-table
    :headers="headers"
    :items="results"
    :items-per-page="10"
    :class="tableClass"
    :single-expand="true"
    show-expand
    item-key="name"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Matches</v-toolbar-title>
      </v-toolbar>
    </template>

    <template slot="no-data">
      <v-avatar color="green" size="40" class="mt-5">
        <v-icon dark>mdi-check</v-icon>
      </v-avatar>
      <p class="mt-3">No Matches!</p>
    </template>

    <template v-slot:item.name="{ item }">
      <span class="caps">{{ item.name }}</span>
      <br :if="item.title" />
      <span :if="item.title" class="overline">{{ item.title }}</span>
    </template>

    <template v-slot:item.score="{ item }">
      <v-chip x-small outlined :color="getColor(item.score)" dark>{{
        getRisk(item.score)
      }}</v-chip>
    </template>

    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <v-container fluid>
          <MatchSummary v-if="item.matchSummary" :summary="item.matchSummary" />
          <br />
          <TargetData :entry="item" />
        </v-container>

        <!-- More info about {{ item.name }} -->
      </td>
    </template>
  </v-data-table>
</template>

<script>
import MatchSummary from "../components/MatchSummary";
import TargetData from "../components/case_report/TargetData.vue"
export default {
  name: "ResultsTable",
  data() {
    return {
      headers: [
        { text: "Sanctioned Entity", value: "name" },
        { text: "Type", value: "type" },
        { text: "Risk", value: "score" },
        { text: "Source", value: "source" },
      ],
    };
  },
  props: {
    results: {},
    tableClass: {
      type: String,
      default: "",
    },
  },
  components: {
    MatchSummary,
    TargetData
  },
  methods: {
    getAkaName(aka) {
      var name = "";
      if (aka.firstName && aka.lastName) {
        name = aka.firstName + " " + aka.lastName;
      } else if (aka.firstName) {
        name = aka.firstName;
      } else if (aka.lastName) {
        name = aka.lastName;
      }
      return name;
    },
    getColor(score) {
      if (score > 96) {
        return "red";
      } else if (score > 92) {
        return "yellow accent-4";
      } else {
        return "green";
      }
    },
    getRisk(score) {
      if (score > 96) {
        return "High";
      } else if (score > 92) {
        return "Medium";
      } else {
        return "Low";
      }
    },
  },
};
</script>